'use client';
import React, { useEffect, useState } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import LeftSidebar from '../components/layout/LeftSidebar';
import SecondaryFooter from '../components/layout/SecondaryFooter';
import { useDispatch } from 'react-redux';
import { getAllKnownBrands } from '@/redux/actions/brand.actions';
import { getHomePageSchema } from '@/utils/schema';
import { UserAuth } from '@/app/context/AuthContext';

const HomeLayout = ({ children, categories, brands }) => {
	const dispatch = useDispatch();
	const { user } = UserAuth();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const fetchBrands = async () => {
			await dispatch(getAllKnownBrands());
			setIsLoading(false);
		};
		fetchBrands();
	}, [dispatch]);

	return (
		<>
			<script
				type='application/ld+json'
				dangerouslySetInnerHTML={{
					__html: JSON.stringify(getHomePageSchema()),
				}}
			/>
			{!user && <Header categories={categories} />}
			{user ? (
				<div className='flex mt-[-8px]'>
					<LeftSidebar />
					<div className='flex-1 min-w-0 px-4 sm:px-6 lg:px-8 mb-5 min-h-[calc(100vh-150px)] pb-5'>
						<div className='w-full h-full px-4 py-4 md:px-9 sm:px-3'>
							{children}
						</div>
					</div>
				</div>
			) : (
				<div className='w-full px-4 sm:px-6 lg:px-8 mb-5 min-h-[calc(100vh-150px)] pb-5'>
					<div className='w-full h-full px-4 py-4 md:px-9 sm:px-3'>
						{children}
					</div>
				</div>
			)}
		<SecondaryFooter />
		</>
	);
};

export default HomeLayout;
